import React, { useState } from "react";
import { HashLink as Link } from "react-router-hash-link";
import headerStyles from "./header.module.css";
import img from "../../images/logo.svg";
import useScrollDirection from "../../hooks/useScrollDirection";
import useMediaQuery from "../../hooks/useMediaQuery";
import MobileMenu from "../mobileMenu/mobileMenu";
import resume from "../../files/ElenaSoloveva.pdf";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState<boolean>(false);

  const scrollDirection = useScrollDirection();
  const hide = headerStyles.hide;
  const mobile = useMediaQuery("(max-width: 780px)");

  const toggleMobileMenu = (): void => {
    setMenuOpen((prevState) => {
      return !prevState;
    });
  };

  return (
    <header
      className={`${headerStyles.header} ${
        scrollDirection === "down" ? hide : "show"
      }`}
    >
      <div className={headerStyles.container}>
        <Link to="/#main" smooth>
          <img className={headerStyles.logo} src={img} alt="Logo" />
        </Link>
        {!mobile ? (
          <nav>
            <ul className={headerStyles.navList}>
              <li>
                <Link to="/#about" smooth className={headerStyles.navLink}>
                  About
                </Link>
              </li>
              <li>
                <Link to="/#jobs" smooth className={headerStyles.navLink}>
                  Experience
                </Link>
              </li>
              <li>
                <Link to="/#projects" smooth className={headerStyles.navLink}>
                  Projects
                </Link>
              </li>
              <li>
                <a className={headerStyles.navLink} href={resume} download>
                  Resume
                </a>
              </li>
            </ul>
          </nav>
        ) : (
          <div>
            <input
              type="checkbox"
              id="burger"
              onChange={toggleMobileMenu}
              checked={menuOpen}
              className={`${headerStyles.checkbox1} ${headerStyles.visuallyHidden}`}
            />
            <label htmlFor="burger">
              <div className={`${headerStyles.hamburger} hamburger`}>
                <span
                  className={`${headerStyles.bar} ${headerStyles.bar1} bar1`}
                />
                <span
                  className={`${headerStyles.bar} ${headerStyles.bar2} bar2`}
                />
                <span
                  className={`${headerStyles.bar} ${headerStyles.bar3} bar3`}
                />
                <span
                  className={`${headerStyles.bar} ${headerStyles.bar4} bar4`}
                />
              </div>
            </label>
            <MobileMenu open={menuOpen} onClick={toggleMobileMenu} />
          </div>
        )}
      </div>
    </header>
  );
};
export default Header;
